module.exports = __webpack_public_path__ + "img/ia-04-8.e7677003.png";